module.exports = __webpack_public_path__ + "img/扬州大学.830c623d.png";